export const courseStatuses = {
  NEW: 1,
  IN_PROGRESS: 2,
  INACTIVE: 5,
  COMPLETED: 10
}

export const courseStatusesNames = {
  1: 'NEW',
  2: 'IN PROGRESS',
  5: 'INACTIVE',
  10: 'COMPLETED'
}
